import source from "@/messages/site-header-interface-source.json";
import mandarinHeaderCopy from "@/messages/mandarin-site-header-interface.json";
export type SiteHeaderInterfaceCopy = typeof source;
/** Identity only; each consuming component passes its live English fields. */
export function mandarinSiteHeaderInterface(
  current: Partial<SiteHeaderInterfaceCopy>
) {
  const keys = Object.keys(current);
  if (
    !keys.length ||
    keys.some(
      (key) =>
        !(key in source) ||
        current[key as keyof SiteHeaderInterfaceCopy] !==
          source[key as keyof SiteHeaderInterfaceCopy]
    )
  )
    throw new Error("Stale Mandarin header interface copy");
  return structuredClone(mandarinHeaderCopy);
}
